export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const TRANSLATIONS_LOADED_SUCCESS = 'TRANSLATIONS_LOADED_SUCCESS';
export const TRANSLATIONS_LOAD_FAILED = 'TRANSLATIONS_LOAD_FAILED';
export const LANGUAGE_TRANSLATIONS_LOAD_SUCCEEDED = 'LANGUAGE_TRANSLATIONS_LOAD_SUCCEEDED';